module.exports = function() {
  return new Worker(__webpack_public_path__ + "a6faf9f5e6248b60f967.worker.js");
};